module.exports = __webpack_public_path__ + "static/img/banner-title.813680c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-title.png
// module id = 5Apu
// module chunks = 1